import { createApi } from '@reduxjs/toolkit/query/react';
import type {
  EmailNotificationLandingRequest,
  EmailNotificationLandingResponse,
  EmailNotificationProductActionRequest,
} from '@ui/analytics/email-notification-attribution';
import { authQuery } from '../config/query.config';

/** Authenticated creator-web API for server-verified notification email landings. */
export const emailNotificationAttributionApi = createApi({
  reducerPath: 'emailNotificationAttributionApi',
  baseQuery: authQuery,
  endpoints: (builder) => ({
    verifyEmailNotificationLanding: builder.mutation<
      EmailNotificationLandingResponse,
      EmailNotificationLandingRequest
    >({
      query: (body) => ({
        url: '/public/v1/email_notification_landings',
        method: 'POST',
        body,
      }),
    }),
    recordEmailNotificationProductAction: builder.mutation<
      void,
      EmailNotificationProductActionRequest
    >({
      query: (body) => ({
        url: '/public/v1/email_notification_product_actions',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useVerifyEmailNotificationLandingMutation,
  useRecordEmailNotificationProductActionMutation,
} = emailNotificationAttributionApi;
